import * as React from 'react';
import { withApollo } from 'react-apollo';
import { withRouter } from 'react-router-dom';
import Navbar from '../../../components/navbar/navbar'
import Header from '../../../components/header/header'
import Footer from  '../../../components/footer/footer'
import Terms_conditionsBanner from '../../../components/terms_conditions/terms_conditionsBanner/terms_condtionsBanner'
import Terms_conditionsContainer from '../../../components/terms_conditions/terms_conditionContainer/terms_conditionContainer'

class  AboutUs extends React.Component{
    constructor(props){
        super(props);
    }

    render() {
        return(
            <div>
              <Navbar />
              <div className="app">
                <Header />
                <Terms_conditionsBanner/>
                <Terms_conditionsContainer/>
            </div> 
            <Footer />       
            </div>
        )
    }
}
 export default withRouter(withApollo(AboutUs));